import React from 'react'
import Mask from '@helpers/Mask'
import IUser from '@interfaces/IUser'

interface PatientInfoCardsProps {
  user: IUser | null
  userPhone: string
}

const PatientInfoCards: React.FC<PatientInfoCardsProps> = ({ user, userPhone }) => {
  return (
    <div className="row g-3 align-items-stretch">
      <div className="col-12 col-sm-12 col-lg-6">
        <div className="info-card info-card--patient">
          <div className="info-card__content">
            <span className="info-card__title">Paciente</span>
            <h6 className="info-card__name">{user?.name}</h6>
            <div className="info-card__grid">
              <div className="info-card__details">
                <span className="info-card__label">CPF/Passaporte</span>
                <p className="info-card__value">{user?.document}</p>
              </div>
              <div className="info-card__details">
                <span className="info-card__label">Telefone</span>
                <p className="info-card__value">{userPhone}</p>
              </div>
              <div className="info-card__details">
                <span className="info-card__label">E-mail</span>
                <p className="info-card__value">{user?.email}</p>
              </div>
              <div className="info-card__details">
                <span className="info-card__label">Estado Civil</span>
                <p className="info-card__value">{user?.patient?.marital_status || '-'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-sm-12 col-lg-6">
        <div className="info-card info-card--partner">
          <div className="info-card__content">
            <span className="info-card__title">Companheiro(a)</span>
            <h6 className="info-card__name">{user?.patient?.partner_name || '-'}</h6>
            <div className="info-card__grid">
              <div className="info-card__details">
                <span className="info-card__label">CPF/Passaporte</span>
                <p className="info-card__value">{user?.patient?.partner_document || '-'}</p>
              </div>
              <div className="info-card__details">
                <span className="info-card__label">Telefone</span>
                <p className="info-card__value">{Mask.cellphoneView(String(user?.patient?.partner_phone))}</p>
              </div>
              <div className="info-card__details">
                <span className="info-card__label">E-mail</span>
                <p className="info-card__value">{user?.patient?.partner_email || '-'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PatientInfoCards
